import Route from '@ember/routing/route';

export default class TermsOfServiceRoute extends Route {
  beforeModel() {
    window.location.assign('https://eula.hashicorp.com/OnlineAgreements.pdf');
    // Prevent navigation
    return new Promise(() => {});
  }
}
